import { useRouter } from 'next/router';
import { useRetriveIteroProposal } from 'reactQuery/queries';
import { useIteroProposalNotificationStore } from 'store';

import { ITeroProposalNotificationModal } from './ITeroProposalNotificationModal';

const ITeroProposalNotification = () => {
  const {
    data: proposalData,
    isLoading: isIteroProposalsLoading,
    isFetching: isIteroProposalsFetching,
  } = useRetriveIteroProposal();

  const showNotification = useIteroProposalNotificationStore(
    state => state.showNotification
  );

  const setShowNotification = useIteroProposalNotificationStore(
    state => state.setShowNotification
  );

  const router = useRouter();

  const redirectToTargetPage = () => {
    setShowNotification(false);
    setShowNotification(false);
    if (proposalData && proposalData.iteroProposals.length === 1) {
      router.push(
        '/iteroscanners/proposals/' +
          proposalData.iteroProposals[0].proposalName
      );
    } else {
      router.push('/iteroscanners/proposals/list');
    }
  };

  return (
    <>
      {showNotification ? (
        <ITeroProposalNotificationModal
          onClose={() => setShowNotification(false)}
          onAccept={() => redirectToTargetPage()}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ITeroProposalNotification;
